import * as React from 'react';
import { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { ListItem } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import {WorkflowAssessmentList} from "../../data/ControlledLists"; 
import { CSVString2Array } from '../../Utilities/Utilities';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ArrowDownwardOutlined, ArrowUpwardOutlined } from '@mui/icons-material';
import { FormControl, InputLabel, MenuItem, Select, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';


 const  PresetWorkflowInformation = ({data, onFieldChange, handleClose, id, cfTemplates, preset}) => {    

    console.log("cftemplates:", cfTemplates);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const onItemSelected = (name) => {
        console.log("Selected: ", name)
        var newString = "";
        if (name !== null && name !== "") {
            if (data.assessmentTypesString === "") {
                newString = name;
            } else {
                newString = data.assessmentTypesString + "," + name;
            } 
            onFieldChange(null, newString, "assessmentTypesString")
        }
    }
    const onClickDelete = (index) => {
        console.log("delete: ", index)

        //setSelectedIndex(index);
        var array = CSVString2Array(data.assessmentTypesString);
        array= array.filter((item, i) => i !== index);

        if (array.length === 0) {
            onFieldChange(null, "", "assessmentTypesString")
        } else {    
            onFieldChange(null, array.join(','), "assessmentTypesString")
        }
    }
    const onClickMoveUp = (index) => {
        console.log("move up: ", index)
        var array = CSVString2Array(data.assessmentTypesString);
        if (index > 0) {
            var temp = array[index-1];
            array[index-1] = array[index];
            array[index] = temp;
            onFieldChange(null, array.join(','), "assessmentTypesString")
        }
    }
    const onClickMoveDown = (index) => {
        console.log("move down: ", index)
        var array = CSVString2Array(data.assessmentTypesString);
        if (index < array.length-1) {
            var temp = array[index+1];
            array[index+1] = array[index];
            array[index] = temp;
            onFieldChange(null, array.join(','), "assessmentTypesString")
        }
    }

    // remove the selected items from the list
    const filterWorkflowAssessmentList = () => {
        var array = CSVString2Array(data.assessmentTypesString);
        return WorkflowAssessmentList.filter((a) => !array.includes(a.name));
    }

    if (data.name !== undefined) {
        return (
            <div>

                <div className='e-input-group e-small'>
                   { data.id === null &&  <TextField
                            fullWidth
                            id="name" 
                            label="Workflow Name" 
                            variant="outlined"
                            className="TextField"
                            size='small'
                            value={data.name}
                            onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                   { data.id !== null &&  <TextField
                            fullWidth
                            disabled
                            id="name" 
                            label="Workflow Name" 
                            variant="outlined"
                            className="TextField"
                            size='small'
                            value={data.name}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                </div>
                <div className='e-input-group e-small'>
                    { data.id === null && <TextField
                            fullWidth
                            id="groupName" 
                            label="Group Name" 
                            variant="outlined"
                            className="TextField"
                            size='small'
                            value={data.groupName}
                            onChange={(event, value) => onFieldChange(event, event.target.value, event.target.id)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                    { data.id !== null && <TextField
                            fullWidth
                            disabled
                            id="groupName" 
                            label="Group Name" 
                            variant="outlined"
                            className="TextField"
                            size='small'
                            value={data.groupName}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                </div>
                {data.id === null && preset === true && 
                <div className='e-input-group e-small'>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Associated CF Template</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="associatedCFTemplate"
                                label="Associated CF Template"
                                value={data.associatedCFTemplate}
                                onChange={(event, value) => onFieldChange(event, event.target.value, "associatedCFTemplate")}
                            >
                                <MenuItem value={null}></MenuItem>
                                {cfTemplates.map((a) => { return ( <MenuItem value={a.featureName}>{a.featureName}</MenuItem>)})}
                            </Select>
                        </FormControl>
                    </div>
                    }
                    { data.id !== null && preset === true && 
                        <div className='e-input-group e-small'>
                            <TextField
                                fullWidth
                                disabled
                                id="associatedCFTemplate" 
                                label="Associated CF Template" 
                                variant="outlined"
                                className="TextField"
                                size='small'
                                value={data.associatedCFTemplate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    }
                    
                {preset === false && data.id === null &&
                    <div className='e-input-group e-small'>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.isFpmEnabled}
                                    onChange={(event, value) => onFieldChange(event, event.target.checked, "isFpmEnabled")}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            }
                            label="FPM Enabled"
                        />
                    </div>
                }
                {preset === false && data.id !== null &&
                <div className='e-input-group e-small'>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={data.isFpmEnabled}
                            disabled
                            onChange={(event, value) => onFieldChange(event, event.target.value, "isFpmEnabled")}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    }
                    label="FPM Enabled"
                />
            </div>
                }
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    {data.id === null &&
                        <div>
                            <div style={{textAlign:'center', fontWeight: 'bold'}}>Assessment Type</div>
                            <Box width={450} height={400} overflow="auto" style={{border: 1, color: 'black', borderStyle: 'solid', borderColor: 'black'}}>
                                <List width={450} component="nav" aria-label="main mailbox folders" dense={true}>
                                    { filterWorkflowAssessmentList().map((a, index) => {
                                            return (
                                                    <ListItem key={index}>
                                                    <ListItemButton onClick={() => onItemSelected(a.name)}>
                                                    <ListItemText primary={a.name} />
                                                    </ListItemButton>
                                                </ListItem>
                                            )
                                        })
                                    }
                                </List>
                            </Box>
                        </div>
                    }
                    <div>
                        <div style={{textAlign:'center', fontWeight: 'bold'}}>Selected Assessment Types</div>
                        <Box width={550} height={400} overflow="auto" style={{border: 1, color: 'black', borderStyle: 'solid', borderColor: 'black'}}>
                            <List width={550} component="nav" aria-label="main" dense={true}>
                                { CSVString2Array(data.assessmentTypesString).map((name, index) => {
                                        return (
                                                <ListItem key={index}>
                                                    <ListItemText primary={name} />
                                                    {data.id === null &&
                                                        <ListItem
                                                            secondaryAction={
                                                                <>
                                                                    {index !== 0 &&<IconButton  aria-label="MoveUp" onClick={() => onClickMoveUp(index)}>
                                                                        <ArrowUpwardOutlined />
                                                                        </IconButton>
                                                                    }
                                                                    {index + 1 < CSVString2Array(data.assessmentTypesString).length &&<IconButton  aria-label="MoveDown" onClick={() => onClickMoveDown(index)}>
                                                                        <ArrowDownwardOutlined />
                                                                        </IconButton>
                                                                    }
                                                                    {index + 1 === CSVString2Array(data.assessmentTypesString).length && 
                                                                    <IconButton>
                                                                        <ArrowDownwardOutlined style={{color: 'white'}} />
                                                                    </IconButton>
                                                                    
                                                                    }
                                                                    <IconButton edge="end" aria-label="delete" onClick={() => onClickDelete(index)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                
                                                            </>
                                                        }
                                                    >
                                                    </ListItem>
                                                }
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                        </Box>
                     </div>
                </div>
            </div>
        );
    } else {
        return (<label>Loading...</label>)
    }
}

export default PresetWorkflowInformation;